"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapGqlCardToOldCard = void 0;
var orientations_1 = require("@wix/wix-vod-constants/dist/video-cards/orientations");
var video_cards_1 = require("../../mappers/video-cards");
function mapGqlCardToOldCard(card, _a) {
    var clientId = _a.clientId;
    return {
        actionId: card.id,
        actionItemId: card.targetVideoId,
        actionListId: card.targetChannelId,
        buttonLabel: card.buttonText,
        type: video_cards_1.cardTypeMapper.toVod(card.type),
        network: card.targetExternalType
            ? video_cards_1.networkMapper.toVod(card.targetExternalType)
            : null,
        text: card.title,
        thumbnailUrl: card.thumbnailUrl,
        url: card.targetExternalUrl,
        updatedTimestamp: card.customOrder,
        clientId: clientId,
        orientation: orientations_1.VIDEO_CARDS_ORIENTATIONS.HORIZONTAL,
        position: video_cards_1.positionMapper.toVod(card.position),
        appearance: {
            start: card.showAt,
            duration: card.hideAt - card.showAt,
        },
    };
}
exports.mapGqlCardToOldCard = mapGqlCardToOldCard;
//# sourceMappingURL=mappers.js.map